import React from 'react'
import { Bars3Icon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline'
import useVersion from '../hooks/useVersion'
import { useAuth } from '../contexts/AuthContext'

const Header = ({ onMenuClick }) => {
  const version = useVersion()
  const { isPasswordProtected, logout } = useAuth()

  return (
    <header className="bg-gray-800 border-b border-gray-700 lg:hidden">
      <div className="flex items-center justify-between px-4 py-3">
        <button
          onClick={onMenuClick}
          className="p-2 rounded-lg text-gray-400 hover:text-white hover:bg-gray-700 transition-colors"
        >
          <Bars3Icon className="h-6 w-6" />
        </button>

        <div className="text-center">
          <h1 className="text-lg font-semibold text-white">
            Homepage 配置管理器
          </h1>
          <span className="text-xs text-gray-400">
            v{version}
          </span>
        </div>

        {/* 登出按钮 - 仅在密码保护模式下显示 */}
        {isPasswordProtected ? (
          <button
            onClick={logout}
            className="p-2 rounded-lg text-gray-400 hover:text-white hover:bg-gray-700 transition-colors"
            title="登出"
          >
            <ArrowRightOnRectangleIcon className="h-5 w-5" />
          </button>
        ) : (
          <div className="w-10" /> /* Spacer for centering */
        )}
      </div>
    </header>
  )
}

export default Header
